import type { MetodoHttp } from './http.tipos'

export type TipoFalhaHttp =
  | 'http'
  | 'rede'
  | 'timeout'
  | 'cancelamento'
  | 'resposta_invalida'

export type ErroDeCampoRecebido = Readonly<{
  campo: string
  codigoRecebido?: string
  mensagemRecebida?: string
}>

export type DadosFalhaHttp = Readonly<{
  tipo: TipoFalhaHttp
  servico: string
  status?: number
  codigoRecebido?: string
  mensagemRecebida?: string
  errosDeCampo?: readonly ErroDeCampoRecebido[]
  metodo?: MetodoHttp
  endpoint?: string
  requestId?: string
  causa: unknown
}>

export class FalhaHttp extends Error {
  readonly tipo: TipoFalhaHttp
  readonly servico: string
  readonly status: number | undefined
  readonly codigoRecebido: string | undefined
  readonly mensagemRecebida: string | undefined
  readonly errosDeCampo: readonly ErroDeCampoRecebido[] | undefined
  readonly metodo: MetodoHttp | undefined
  readonly endpoint: string | undefined
  readonly requestId: string | undefined
  readonly causa: unknown

  constructor(dados: DadosFalhaHttp) {
    super('Falha ao executar requisicao HTTP')
    this.name = 'FalhaHttp'
    this.tipo = dados.tipo
    this.servico = dados.servico
    this.status = dados.status
    this.codigoRecebido = dados.codigoRecebido
    this.mensagemRecebida = dados.mensagemRecebida
    this.errosDeCampo = dados.errosDeCampo
    this.metodo = dados.metodo
    this.endpoint = dados.endpoint
    this.requestId = dados.requestId
    this.causa = dados.causa
  }
}
